// d:\typebattle\frontend\src\components\ui\Footer.jsx

import { FileText, Shield, Lock } from "lucide-react";

// lucide-react dropped brand/logo icons (including GitHub); inline SVG
// keeps the same 14px sizing/stroke look as the other footer icons.
function GithubIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.08 3.29 9.39 7.86 10.91.57.1.78-.25.78-.55 0-.27-.01-1.17-.02-2.12-3.2.7-3.88-1.36-3.88-1.36-.52-1.34-1.28-1.7-1.28-1.7-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.7 0-1.26.45-2.29 1.19-3.09-.12-.29-.52-1.47.11-3.06 0 0 .97-.31 3.18 1.18a11 11 0 0 1 5.8 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.59.23 2.77.11 3.06.74.8 1.19 1.83 1.19 3.09 0 4.43-2.7 5.41-5.26 5.69.41.36.78 1.06.78 2.14 0 1.55-.01 2.79-.01 3.17 0 .3.2.66.79.55A10.51 10.51 0 0 0 23.5 12C23.5 5.73 18.27.5 12 .5Z" />
    </svg>
  );
}
import { useNavigate, useLocation } from "react-router-dom";
import { APP_VERSION } from "@/utils/constants";

const PROFILE_URL = "https://github.com/deylsnts";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full py-6 md:py-8 mt-auto border-t border-zinc-800/50 bg-zinc-950/50 backdrop-blur-md relative z-10 shrink-0">
      <div className="max-w-7xl mx-auto px-6 md:px-8 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">

        {/* Left: Branding + copyright */}
        <div className="flex flex-col md:flex-row items-center gap-1.5 md:gap-3 text-center md:text-left">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-emerald-500/70 rounded-full animate-pulse" />
            <span className="text-[10px] font-black text-zinc-400 uppercase tracking-widest">
              TypeBattle
            </span>
          </div>
          <div className="h-3 w-px bg-zinc-800 hidden md:block" />
          <span className="text-[10px] font-mono text-zinc-600 uppercase tracking-widest">
            &copy; {year} &middot; {APP_VERSION}
          </span>
        </div>

        {/* Right: Links */}
        <div className="flex items-center gap-6 md:gap-8">
          <a
            href={PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile"
            className="group flex items-center gap-2 text-zinc-500 hover:text-indigo-400 transition-colors"
          >
            <GithubIcon size={14} />
            <span className="text-[10px] font-black uppercase tracking-wider hidden md:block" aria-hidden="true">GitHub</span>
          </a>

          <div className="h-3 w-px bg-zinc-800 hidden md:block" />

          <div className="flex items-center gap-4 md:gap-6">
            <button onClick={() => navigate(location.pathname, { state: { open: 'terms' } })} className="text-[10px] font-bold uppercase tracking-wider text-zinc-600 hover:text-zinc-300 transition-colors flex items-center gap-1.5 outline-none">
              <FileText size={12} /> Terms
            </button>
            <button onClick={() => navigate(location.pathname, { state: { open: 'security' } })} className="text-[10px] font-bold uppercase tracking-wider text-zinc-600 hover:text-zinc-300 transition-colors flex items-center gap-1.5 outline-none">
              <Shield size={12} /> Security
            </button>
            <button onClick={() => navigate(location.pathname, { state: { open: 'privacy' } })} className="text-[10px] font-bold uppercase tracking-wider text-zinc-600 hover:text-zinc-300 transition-colors flex items-center gap-1.5 outline-none">
              <Lock size={12} /> Privacy
            </button>
          </div>
        </div>

      </div>
    </footer>
  );
}
